import { SlideWrap } from './styles';

import Button from '../../../../components/Button';

import React from 'react';

const Slide = () => {
  return (
    <SlideWrap>
      <img
        src="/img/slogan_banner.png"
        alt="Imagem única de banner principal: Solicite sua lavagem!"
      ></img>
      <Button
        className="bounceInLeft"
        onClick={e => {
          document.location += '#app';
          return false;
        }}
      >
        Solicitar Ecolavagem
      </Button>
      <span>
        * Atendimento apenas em região de Lauro de Freitas - BA
      </span>
    </SlideWrap>
  );
};

export default Slide;
